import logoInitial from "../../assets/png/Netuno_Logo_dark.png";
import { textSignUpConfirm, textNewPass } from "../../locales/es-es";
import { useForm } from "../../Hooks/UseForm";
import { Link, useLocation, useRoutes } from "react-router-dom";
import { initialRecover, newPassword } from "../../propsType/RecoverPassword";
import { validationNewPassword } from "../../validations/formValidations";
import ButtonGeneric from "../../components/Buttons/ButtonGeneric";
import InputGeneric from "../../components/Inputs/InputGeneric";
import { colors } from "../../propsType/Colors";
import { useEffect, useState } from "react";
import AuthController from "../../controllers/AuthController";
import Modal from "../../components/Modals/Modal";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";


const SignUpConfirm = () => {
  const location = useLocation().search;
  /*const token = location.search.split("&")[1].split("=")[1];
  const email = location.search.split("=").pop();*/
  const { form, errors, setForm, handleChange, handleSubmit, handleBlur } = useForm(
    newPassword,
    validationNewPassword
  );
  const [loading, setLoading] = useState(false);
  const { recoverConfirm } = AuthController();
  const [activeModal, setActiveModal] = useState(false);
  const [check, setCheck] = useState(false);
  const [message, setMessage] = useState("");
  const [showConfirPassword, setShowConfirPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const sendNewPass = async () => 
  {
    const result = handleSubmit();
    window.location.href='/cuenta';
    
  };


const closetModal = () => 
{
  setActiveModal(false);
  setMessage("");

}

  //Funcion para mostar el input tipo password
  const funtionShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const funtionShowConfirPassword = () => {
      setShowConfirPassword(!showConfirPassword);
  };

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

return (
  <>
    <div className="h-screen  lg:flex">
      <div className="flex-1  flex flex-col w-auto lg:w-[44%] h-screen py-4 xl:overflow-hidden justify-center  px-4 sm:px-6 md:flex-none lg:px-0 xl:px-0">
          {loading ? (
            <>
              <Spinner title={"Espere..."} />
            </>
          ) : (
            <>
        <div className="mx-auto w-full  md:max-w-sm overflow-y-auto  lg:mt-0 px-4 xl:max-w-lg xl:w-[32rem]">
          <div>
            <img className="h-12 w-auto" src={logoInitial} alt="Workflow" />
            <h2 className="mt-6 text-1xl font-extrabold text-gray-900">
              {textSignUpConfirm.confirmar}{" "}
            </h2>
            <p className={`text-sm font-medium text-[${colors.lightBlue}]`}>
              {textNewPass.acceder}{" "}
            </p>
          </div>
          <div className="mt-8">
            <div className="mt-6">

              <div className="space-y-6 mt-5">

                <div>
                  <ButtonGeneric
                    funtion = {sendNewPass}
                    bgButton={colors.darkBlue}
                    text={"Ingresa a tu Cuenta"}
                    to={"/cuenta"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
      )}
      </div>
      <div
        className={`hidden bg-[url("../public/banner.jpg")] border-[${colors.darkBlue}] border-l-4 bg-cover bg-center bg-no-repeat lg:block relative w-0 flex-1`}
      >
      </div> 
    </div>
  </>
);
};
export default SignUpConfirm;
